<template>
  <div class="home-page" id="page" v-cloak>
    <!-- 顶部 -->

    <van-sticky :offset-top="0" @scroll="scrollTopSearch">
      <!-- 黏顶搜索框 -->
      <div class="sticky-search-block">

        <!-- 去分类 -->
        <div class="search-icon-left" @click="goPage({ url: 'category', query: {} })">
          <img src="../../assets/home/icon1.png" alt="" />
          <p>分类</p>
        </div>

        <div class="sticky-search-input" @click="onSearch">
          <van-icon name="search" class="search-icon" />
          搜索您喜欢的物品
        </div>

        <!-- 消息 -->
        <div class="search-icon-right" @click="dialPhoneNumber()">
          <img src="../../assets/home/icon2.png" alt="" />
          <p>消息</p>
        </div>
      </div>
    </van-sticky>

    <!-- 轮播图 -->
    <div class="swipe-block">
      <van-swipe class="my-swipe" :autoplay="3000">
        <van-swipe-item v-for="(image, index) in banner" :key="index" @click="goOpenSwipe(image)"><img :src="image.pic" /></van-swipe-item>
      </van-swipe>
    </div>

    <!-- 5图标 -->
    <div class="swipe-icon">
      <div class="swipe-ddd" v-for="(im, ind) in iconList" :key="ind" @click="goswipePage(im)">
        <div class="icon-img"><img :src="im.image" alt="" /></div>
        <p class="icon-title">{{im.label}}</p>
      </div>
    </div>

    <!-- 活动模块头 v-if="newListInfo.image"  -->
    <div class="activity-header" @click="goOpenPage(1)">
      <img src="../../assets/index/index_1.jpg" alt="" />
    </div>

    <div class="activity-header" @click="goOpenPage(2)">
      <img src="../../assets/index/index_2.jpg" alt="" />
    </div> 

    <!-- 底部活动区 开始 -->
    <div class="food-block" v-for="(item,index) in floor" :key="index">

      <div class="food-header van-hairline--bottom">
        <img :src="item.pic" alt="">
      </div>

      <div class="food-left ">
        <!-- <div > -->
        <div v-for="(itGoods,inGoods) in item.goods" :key="inGoods" class="food-left-one van-hairline--bottom van-hairline--right" @click="goGoodsDetails(itGoods)">
          <p class="food-left-one-title van-ellipsis">{{itGoods.title}}</p>
          <p class="food-left-one-subtitle van-ellipsis">{{itGoods.subtitle}}</p>
          <div class="food-left-one-img" v-if="itGoods.pic">
            <img class="van-hairline--surround" :src="itGoods.pic" alt="">
          </div>

        </div>
        <!-- </div> -->
      </div>

    </div>
    <!-- 底部活动区 结束 -->

  </div>
</template>

<script type="text/babel">
import wx from "weixin-js-sdk";
import sdk from "../../utils/wechart"; //引入sdk.js
import config from "@/common/environment.js";
const redirect_uri = encodeURIComponent(config.REDIRECT_URI);
const appid = config.APPID;

export default {
  components: {},
  props: {},
  data() {
    return {
      // 轮播图
      banner: [
        // {
        //   title: "", //标题
        //   pic: "http://www.xzbfb.com/UploadFiles/ads/2017070515240246454159.jpg", //图片
        //   url: "", //链接i地址
        // },
        // {
        //   title: "",
        //   pic: "http://www.xzbfb.com/UploadFiles/ads/2022083014194484734020.jpg",
        //   url: "",
        // },
        // {
        //   title: "",
        //   pic: "https://qiniu.zdyxjx.com/v3/pic/1b3f806601e2463d8b3995c46e052fcc.jpg",
        //   url: "",
        // },
      ],

      iconList: [
        {
          id: "1",
          ind: "2",
          label: "兑换专区",
          path: "/exchange",
          image: require("../../assets/home/nav2.png"),
        },
        {
          id: "2",
          ind: "5",
          label: "优惠券派送",
          path: "/coupon-list",
          image: require("../../assets/home/nav7.png"),
        },
        {
          id: "3",
          ind: "0",
          label: "特价商品",
          path: "/product-tj",
          image: require("../../assets/home/nav3.png"),
        },
        {
          id: "4",
          ind: "0",
          label: "生日礼专区",
          path: "/birth-company-list/0",
          image: require("../../assets/home/nav8.png"),
        },
        {
          id: "5",
          ind: "1",
          label: "在线客服",
          path: "1",
          image: require("../../assets/home/nav5.png"),
        },
      ],
 

      floor: [
        // {
        //   id: "1", //楼层id
        //   floor_title: "流行时尚", //楼层标题
        //   remark: "楼层备注",
        //   pic: require("../../assets/home/title_1.jpg"), //楼层图片
        //   limit: "",
        //   goods: [
        //     {
        //       c_type: 2, //"类型：1=商品 2=专区",
        //       r_id: 1234, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题商品商品标题商品商品标题商品商品标题商品", //标题
        //       subtitle: "子标题子标题子标题子标题子标题",
        //       pic: require("../../assets/home/car.png"), //楼层图片
        //     },
        //     {
        //       c_type: 1, //"类型：1=商品 2=专区",
        //       r_id: 242, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/home/nav3.png"), //楼层图片
        //     },
        //     {
        //       c_type: 1, //"类型：1=商品 2=专区",
        //       r_id: 434, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/home/nav5.png"), //楼层图片
        //     },
        //     {
        //       c_type: 1, //"类型：1=商品 2=专区",
        //       r_id: 4645, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/home/nav7.png"), //楼层图片
        //     },
        //     {
        //       c_type: 1, //"类型：1=商品 2=专区",
        //       r_id: 333, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/home/nav8.png"), //楼层图片
        //     },
        //   ],
        // },
        // {
        //   id: "2", //楼层id
        //   floor_title: "进口商品", //楼层标题
        //   remark: "楼层备注",
        //   pic: require("../../assets/home/title_2.jpg"), //楼层图片
        //   limit: "",
        //   goods: [
        //     {
        //       c_type: 2, //"类型：1=商品 2=专区",
        //       r_id: 3334, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/car-guide/l_icon.png"), //楼层图片
        //     },
        //     {
        //       c_type: 2, //"类型：1=商品 2=专区",
        //       r_id: 3334, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/login/icon-eye-on.png"), //楼层图片
        //     },
        //     {
        //       c_type: 2, //"类型：1=商品 2=专区",
        //       r_id: 3334, //"c_type=1,是商品id，=2是专区id",
        //       title: "商品标题", //标题
        //       subtitle: "子标题",
        //       pic: require("../../assets/nav/cart_icon_active.png"), //楼层图片
        //     },
        //   ],
        // },
      ],

      balance: {
        total: 0, //总额
        true_amt: 0, //充值账户剩余金额
        gift_amt: 0, //赠送账户剩余金额
      },

      user: {
        user_nickname: "", //昵称
        head_photo: "", //头像
        phone_no: "", //电话
      },
    };
  },
  created() {
    this.getIndex();
    this.shareDetail();
    this.user = Lockr.get("userInfo"); //用户信息
    console.log("跑接口");
  },
  mounted() {
    // this.getIndex();
    // this.shareDetail();
    // this.user = Lockr.get("userInfo"); //用户信息
  },
  destroyed() {},
  methods: {
    // 新 跳转
    goOpenPage(even) {
      let _this = this;
      // console.log(even)
      if (even == 2) {
        // 无跳转
        // _this.$toast.fail("敬请期待！");
        window.location.href = 'http://dajiankang.xzbfb.com';
        return;
      } else {
        window.location.href = 'http://xzlm.bijingauto.cn/web/#/index';
      }
    },
    // 新 跳转
    goswipePage(even) {
      let _this = this;
      // console.log(even)
      if (!even.path) {
        // 无跳转
        _this.$toast.fail("敬请期待！");
        return;
        // } else if (even.id == 2) {
        //   this.$router.push({ path: even.path });
        // } else if (even.id == 3) {
        //   // 自定跳转
        //   window.location.href = even.path;
      } else if (even.id == 5) {
        this.MakeCall(); //拨打电话
      } else {
        this.$router.push({ path: even.path });
      }
    },

    goGoodsDetails(even) {
      console.log(even);
      if (even.c_type == 2) {
        this.$router.push({
          name: "activity",
          query: {
            mid: even.r_id,
          },
        });
        // this.$router.push({ path: `/product-details/${even.r_id}` });
      } else {
        this.$router.push({ path: `/product-details/${even.r_id}` });
      }
    },

    ////监听滚动 是否吸顶
    scrollTopSearch(e) {
      // console.log(e);
      // this.isTopSearch = e.isFixed;
    },

    // 新 跳转
    openUrl(even) {
      let _this = this;
      if (!this.isLogin()) return false;
      // console.log(even)
      if (!even.url) {
        _this.$toast.fail("敬请期待！");
        // 无跳转
        return;
      } else {
        // 自定跳转
        this.$router.push({ name: even.url, query: {} });
        // window.location.href = even.templateName;
      }
    },

    // 条搜索
    onSearch() {
      this.$router.push({ name: "search", query: {} });
    },
    // 条路有
    goPage(even) {
      let _this = this;
      if (!this.isLogin()) return false;
      // console.log(even)
      if (!even.url) {
        _this.$toast.fail("敬请期待！");
        // 无跳转
        return;
      } else {
        this.$router.push({ name: even.url, query: even.query });
      }
    },   
    goOpenSwipe(even) {
      let _this = this;
      if (!this.isLogin()) return false;
      // console.log(even)
      if (!even.url) {
        _this.$toast.fail("敬请期待！");
        // 无跳转
        return;
      } else {
        window.location.href = even.url; 
      }
    }, 
    // 拨打电话
    // dialPhoneNumber() {
    //   this.MakeCall(); //拨打电话
    // },

    // // 跳商品详情
    // goProductDetails(product) {
    //   // console.log(product)
    //   this.$router.push({
    //     name: "product-details",
    //     query: {
    //       productId: product.id,
    //     },
    //   });
    // },
    // 首页 底部table
    getIndex() {
      let _this = this;
      this.$toast.loading();
      let data = {
        location_id: 1,
        limit: 6,
      };
      _this.$post("/api/index").then((res) => {
        console.log(res.data, "底部table");
        if (res.data && res.data.code == 0) {
          this.banner = res.data.data.banner || [];
          this.floor = res.data.data.floor || [];

          this.$toast.clear();
        }
      });
    },
    // 首页 底部table
    getHomeSettingTopics() {
      let _this = this;
      console.log(Lockr.get("beforeLoginUrl"));
      let localRoute = "1660020991200";
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${localRoute}#wechat_redirect`;
    },

    // 分享商品
    shareDetail() {
      let _this = this;

      var referral_code =
        Lockr.get("referral_code") || this.$store.getters.referral_code; //邀请码

      let menuList = [
        // "menuItem:share:timeline", //朋友圈
        // "menuItem:share:appMessage", //发送给朋友
        "menuItem:share:qq", //分享到QQ
        "menuItem:share:weiboApp", // 分享到Weibo
        "menuItem:favorite", // 收藏
        "menuItem:share:QZone", // 分享到 QQ 空间
        "menuItem:copyUrl", // 复制链接
        "menuItem:openWithQQBrowser", // 在QQ浏览器中打开
        "menuItem:openWithSafari", // 在Safari中打开
        "menuItem:share:email", // 邮件
        "menuItem:readMode", // 阅读模式
        "menuItem:originPage", // 原网页
      ];
      let params = "?invite_code=" + referral_code;
      var url = window.location.href.split("#")[0];
      var obj = {
        title: "百分百生活馆", //分享标题
        desc: "精选好物 只在百分百", //分享内容
        linkurl:
          location.protocol + "//" + location.host + "/html/#/index" + params,
        img: "http://weizhui.xzbfb.com/html/share_icon.png", //分享内容显示的图片
      };
      sdk.getJSSDK(url, obj, menuList);
    },
  },
};
</script>
<style lang="scss">
// 轮播图 图标颜色
.home-page {
  .van-swipe__indicators {
    .van-swipe__indicator {
      width: 10px;
      height: 10px;
    }
    .van-swipe__indicator--active {
      background-color: #ff5001 !important;
    }
  }
  .van-stepper {
    .van-stepper__minus {
      color: #ff5001 !important;
      border-color: #ff5001 !important;
    }
    .van-stepper__minus--disabled {
      color: #666666 !important;
      border-color: #666666 !important;
    }
    .van-stepper__plus {
      background-color: #ff5001 !important;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/styles/index.scss";
.home-page {
  width: 100%;
  background-color: #f7f7f7;
  padding-bottom: 50px;
}

// 黏顶搜索框
.sticky-search-block {
  width: 100%;
  height: 45px;
  background-color: #ff5001;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .sticky-search-input {
    width: 235px;
    height: 29px;
    background: #d52d00;
    // color: #ea9680;
    color: #ddd;
    border-radius: 3px;
    padding-left: 10px;
    // opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    .search-icon {
      font-size: 24px;
    }
  }

  .search-icon-left {
    width: 30px;
    // height: 20px;
    p {
      font-size: 12px;
      color: #ffffff;
      margin-top: 3px;
      text-align: center;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 24px;
      height: 17px;
    }
  }
  .search-icon-right {
    width: 30px;
    // height: 20px;
    p {
      font-size: 12px;
      color: #ffffff;
      margin-top: 3px;
      text-align: center;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 20px;
      height: 20px;
    }
  }
}

// 轮播
.swipe-block {
  height: 156px;
  display: flex;
  align-items: center;
  // background-color: paleturquoise;

  .my-swipe,
  .my-swipe .van-swipe-item {
    height: 100%;
    width: 100%;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 輪播圖標
.swipe-icon {
  width: 100%;
  height: 90px;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .swipe-ddd {
    // height: 90px;
    width: 75px;

    .icon-img {
      width: 45px;
      height: 45px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .icon-title {
      margin-top: 5px;
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #363636;
    }
  }
}

//掌上抢  限时活动
.limit-activi {
  margin: 8px 0;
  background-color: #fff;
  padding: 4px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .limit-activi-left {
    display: inline-block;
    height: 25px;
    img {
      display: block;
      width: 70px;
      height: 25px;
    }
  }
  .limit-activi-title {
    color: #ff5001;
    font-style: normal;
    font-size: 14px;
  }

  .limit-activi-right {
    height: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    .limit-activi-right-title {
      display: inline-block;
      color: #9d9d9d;
      font-style: normal;
      font-size: 12px;
      margin-right: 15px;
      line-height: 20px;
      position: relative;
    }
    .limit-activi-right-title::before {
      content: "";
      position: absolute;
      width: 7px;
      height: 12px;
      left: 30px;
      top: 2px;
      z-index: 1;
      // background-color: #555;
      background-image: url("../../assets/home/more.jpg");
      background-repeat: no-repeat;
      background-position: 0 0;
      background-size: 100% 100%;
      //
    }

    // .limit-activi-right-img {
    //   display: inline-block;
    //   height: 13px;
    //   img {
    //     display: block;
    //     height: 100%;
    //   }
    // }
  }
}

.food-block {
  width: 100%;
  // height: 300px;
  background-color: #fff;
  margin-bottom: 20px;

  // 顶部图片
  .food-header {
    // height: 30px;
    width: 100%;
    padding: 10px 0;
    // border-bottom: 1px solid #f2f2f2;
    // background-color: saddlebrown;
    img {
      width: 128px;
      display: block;
      margin: 0 auto;
    }
  }

  //左侧
  .food-left {
    padding: 5px 0 0;
    // width: 50%;
    // height: 300px;
    // background-color: forestgreen;
    overflow: hidden;

    .food-left-one {
      float: left;
      width: 50%;
      // margin: 0 5px;
      padding: 10px;
      .food-left-one-title {
        text-align: left;
        font-size: 14px;
        line-height: 18px;
        color: #383838;
        margin-bottom: 5px;
      }
      .food-left-one-subtitle {
        text-align: left;
        font-size: 12px;
        line-height: 18px;
        color: #9c9c9c;
        margin-bottom: 10px;
      }
      .food-left-one-img {
        height: 68px;
        width: 100%;
        display: flex;
        justify-content: end;
        align-items: center;
        img {
          height: 100%;
          display: block;
          // margin: 0 auto;
        }
      }
    }
  }
  .food-right {
  }
}

//-----------------------------------------------------------------------------------------=
// 顶部余额
.header-balance {
  margin: 0 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-left {
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
  &-right {
    padding: 5px 13px;
    background: rgba(255, 255, 255, 0.6);
    border: 1px solid #2998ff;
    border-radius: 12px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #2897ff;
  }
}
//
.center-bander {
  margin: 15px;
  padding: 15px 0 0;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;

  .bc0 {
    background: linear-gradient(0deg, #f7f7f9 0%, #fcfcfa 100%);
  }
  .bc1 {
    background: linear-gradient(0deg, #bdddf2 0%, #f4f2ff 100%);
  }
  .bc2 {
    background: linear-gradient(0deg, #fff4dd 0%, #f6f6f7 100%);
  }

  .center-bander-item {
    box-sizing: border-box;
    width: 45%;
    margin: 0 8px 15px;
    border: 1px solid #d4d3da;

    border-radius: 12px;

    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 15px;
    .icon-img {
      width: 43px;
      height: 43px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .icon-title {
      margin-top: 5px;
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #555555;
    }
  }
}

.list {
  padding: 5px 0 100px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}

// 活动模块头
.activity-header {
  width: 100%;
  height: 90px;
  margin: 10px 0;
  // background-color:peru;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
